module.exports = __webpack_public_path__ + "img/Corporate social responsibility Icon - white.46a020c8.svg";